import styled from 'styled-components';
import { ErrorBoundary } from './ErrorBoundary';

export const StyledErrorBoundary = styled(ErrorBoundary)`
	position: fixed;
	width: 100%;
	height: 100%;
	isolation: isolate;
	pointer-events: none;

	> * {
		pointer-events: all;
	}
`;

export const StyledErrorPopup = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	display: grid;
	place-items: center;
	text-align: center;
	font-weight: bold;
	font-size: 20px;
	color: #ccc;
	pointer-events: none;
`;
